export function buildCourseFormData({
     nameEn,
     nameAr,
     descriptionEn,
     descriptionAr,
     price,
     discountPrice,
     isFree,
     levelEn,
     levelAr,
     objectivesEn,
     objectivesAr,
     prerequisitesEn,
     prerequisitesAr,
     image,
     introVideo,
     discountStartAt,
     discountEndAt,
     categoryId,
     majors
}) {
     const formData = new FormData();
     formData.append('name_en', nameEn);
     formData.append('name_ar', nameAr);
     formData.append('description_en', descriptionEn);
     formData.append('description_ar', descriptionAr);
     formData.append('price', price);
     if (discountPrice !== '' && discountPrice != null) formData.append('discount_price', discountPrice);
     if (isFree) formData.append('is_free', '1');
     if (levelEn) formData.append('level_en', levelEn);
     if (levelAr) formData.append('level_ar', levelAr);
     if (objectivesEn) formData.append('objectives_en', objectivesEn);
     if (objectivesAr) formData.append('objectives_ar', objectivesAr);
     if (prerequisitesEn) formData.append('prerequisites_en', prerequisitesEn);
     if (prerequisitesAr) formData.append('prerequisites_ar', prerequisitesAr);
     if (image instanceof File || image instanceof Blob) {
          formData.append('image', image);
     }
     if (introVideo instanceof File || introVideo instanceof Blob) {
          formData.append('intro_video', introVideo);
     }
     if (discountStartAt) formData.append('discount_start_at', discountStartAt);
     if (discountEndAt) formData.append('discount_end_at', discountEndAt);
     formData.append('category_id', categoryId);
     majors.forEach((id) => { formData.append('major_ids[]', id); });
     return formData;
}